import { createSelector } from "reselect";
import { tFreightData, tContentText, tLink, tContent, tContacts, tCarriers, tCarriersStats } from "../types";

const getState = (state) => state.freightReducer.freight;

const freightSelector = createSelector([getState], (item) => {

    let results: tFreightData;

    if (item) {


        let content: tContent[] = [];
        let link: tLink;
        let contacts: tContacts;

        const { attributes } = item;
        if (attributes && attributes.Content && attributes.Content.length > 0) {
            attributes.Content.forEach(cont => {

                let contentText: tContentText[] = [];

                if (cont && cont.ContentText && cont.ContentText.length > 0) {
                    cont.ContentText.forEach(text => {

                        let carriers: tCarriers[] = [];
                        if (text.Carriers && text.Carriers.data && text.Carriers.data.length > 0) {
                            text.Carriers.data.forEach(carrier => {

                                let stats: tCarriersStats[] = [];

                                if (carrier.attributes.Stats && carrier.attributes.Stats.length > 0) {
                                    carrier.attributes.Stats.forEach(stat => {
                                        stats = [
                                            ...stats,
                                            {
                                                id: stat.id,
                                                title: stat.Title,
                                                value: stat.Value,
                                            }
                                        ];
                                    });
                                }

                                carriers = [
                                    ...carriers,
                                    {
                                        id: carrier.id,
                                        title: carrier.attributes.Title,
                                        stats,
                                    }
                                ];
                            });
                        }

                        contentText = [
                            ...contentText,
                            {
                                id: text.id,
                                title: text.Title,
                                description: text.Description,
                                carriers,
                            }
                        ];
                    });
                }

                content = [
                    ...content,
                    {
                        id: cont.id,
                        title: cont.Title,
                        text: contentText,
                        image: cont.Image && cont.Image.data && cont.Image.data.attributes && cont.Image.data.attributes.url && cont.Image.data.attributes.url,                        link,
                    }
                ];

            });
        }


        if (attributes && attributes.Contacts) {
            let link: tLink = null;
            if (attributes.Contacts.Link && attributes.Contacts.Link.Title && attributes.Contacts.Link.Url) {
                link = {
                    title: attributes.Contacts.Link.Title,
                    url: attributes.Contacts.Link.Url,
                };
            }

            contacts = {
                title: attributes.Contacts.Title,
                description: attributes.Contacts.Description,
                link,
            };
        }

        results = {
            id: item.id,
            title: attributes && attributes.Title,
            description: attributes && attributes.Description,
            content,
            contacts,
        }
    }

    return results;
});

export default freightSelector;
